<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Configure Revenue Accounts</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <p>
      Enter each account on a separate line. Each line must contain an account code and account name, joined by a comma, as in the following example:
    </p>

    <p class="p-2 bg-light rounded border">
      101,Annual Memberships <br>
      102,Monthly Memberships <br>
      103,Day Passes
    </p>

    <textarea [(ngModel)]="inputAccountsText" class="form-control" rows="10"></textarea>

    <p class="mt-4">
      You may additionally configure the account to which deposits will be made when exporting data for accounting software.
    </p>

    <div class="form-group">
      <label for="inputDepositAccountId">Deposit Account Code</label>
      <input type="text" class="form-control"
             id="inputDepositAccountId" name="inputDepositAccountId"
             [(ngModel)]="inputDepositAccountId">
    </div>

    <div class="form-group">
      <label for="inputDepositAccountName">Deposit Account Name</label>
      <input type="text" class="form-control"
             id="inputDepositAccountName" name="inputDepositAccountName"
             [(ngModel)]="inputDepositAccountName">
    </div>

    <div class="alert alert-danger mt-3 mb-0" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-primary"
            (click)="handleSubmit()"
            *ngIf="!loadingSave">
      Save
    </button>
    <button class="btn btn-primary disabled" type="button" disabled
            *ngIf="loadingSave">
      Loading...
    </button>
  </div>

</ng-container>
